<template>
  <div class="modal-overlay">
    <div class="mmodal-content" style="max-width: 80vw">
      <div class="modal-header">
        <h3>{{ editingRecord ? "Edit" : "Add" }} Physiotherapy Session</h3>
        <button type="button" class="close" @click="closeModal">&times;</button>
      </div>
      <div class="modal-body">
        <form @submit.prevent="saveRecord">
          <div class="form-grid">
            <div class="form-group">
              <label>Session Date *</label>
              <input type="datetime-local" v-model="form.session_date" required class="form-control" />
            </div>

            <div class="form-group ">
              <label>Affected Area *</label>
              <input type="text" v-model="form.affected_area" required class="form-control" />
            </div>

            <div class="form-group ">
              <label>Pain Score (0-10)</label>
              <input type="number" v-model="form.pain_score" min="0" max="10"  class="form-control" />
            </div>

            <div class="form-group ">
              <label>Range of Motion</label>
              <input type="text" v-model="form.range_of_motion"  class="form-control" />
            </div>

            <div class="form-group ">
              <label>Muscle Strength</label>
              <input type="text" v-model="form.muscle_strength" placeholder="e.g. MRC 4/5"  class="form-control" />
            </div>

            <div class="form-group ">
              <label>Gait</label>
              <input type="text" v-model="form.gait"  class="form-control" />
            </div>

            <div class="form-group full-width">
              <label>Presenting Complaint</label>
              <textarea v-model="form.presenting_complaint" class="form-control" rows="2"></textarea>
            </div>

            <div class="form-group full-width">
              <label>Treatment Given</label>
              <textarea v-model="form.treatment_given" class="form-control" rows="2"></textarea>
            </div>

            <div class="form-group full-width">
              <label>Exercises Prescribed</label>
              <textarea v-model="form.exercises_prescribed" class="form-control" rows="2"></textarea>
            </div>

            <div class="form-group ">
              <label>Session Number</label>
              <input type="number" v-model="form.session_number" min="1"  class="form-control" />
            </div>

            <div class="form-group ">
              <label>Sessions Planned</label>
              <input type="number" v-model="form.sessions_planned" min="1"  class="form-control" />
            </div>

            <div class="form-group ">
              <label>Next Session Date</label>
              <input type="date" v-model="form.next_session_date"  class="form-control" />
            </div>

            <div class="form-group full-width">
              <label>Progress Notes</label>
              <textarea v-model="form.progress_notes" class="form-control" rows="2"></textarea>
            </div>

            <div class="form-group full-width">
              <label>Notes</label>
              <textarea v-model="form.notes" class="form-control" rows="2"></textarea>
            </div>

            <div class="form-group ">
              <label>Seen By</label>
              <input type="text" v-model="form.seen_by"  class="form-control" />
            </div>
          </div>

          <div class="modal-actions">
            <button type="button" class="btn btn-secondary" @click="closeModal">Cancel</button>
            <button type="submit" class="btn btn-primary" :disabled="saving">
              {{ saving ? "Saving..." : (editingRecord ? "Update" : "Save") + " Session" }}
            </button>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import { generalApiRequest } from "../../../api/apiIndex";

export default {
  name: "PhysiotherapySessionModal",
  props: {
    visitId: { type: [Number, String], default: null },
    editRecord: { type: Object, default: null },
  },
  data() {
    return {
      saving: false,
      editingRecord: null,
      form: this.emptyForm(),
    };
  },
  created() {
    if (this.editRecord) {
      this.editingRecord = this.editRecord;
      this.form = {
        ...this.emptyForm(),
        ...this.editRecord,
        session_date: this.toLocalDateTime(this.editRecord.session_date),
      };
    }
  },
  methods: {
    emptyForm() {
      return {
        session_date: this.toLocalDateTime(new Date()),
        affected_area: "",
        pain_score: "",
        range_of_motion: "",
        muscle_strength: "",
        gait: "",
        presenting_complaint: "",
        treatment_given: "",
        exercises_prescribed: "",
        session_number: "",
        sessions_planned: "",
        next_session_date: "",
        progress_notes: "",
        notes: "",
        seen_by: ""
      };
    },
    toLocalDateTime(value) {
      if (!value) return "";
      const d = new Date(value);
      if (isNaN(d.getTime())) return "";
      const pad = (n) => String(n).padStart(2, "0");
      return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}T${pad(d.getHours())}:${pad(d.getMinutes())}`;
    },
    closeModal() {
      this.$emit("close");
    },
    async saveRecord() {
      this.saving = true;
      try {
        const payload = { ...this.form, visit_id: this.visitId };
        let response;
        if (this.editingRecord) {
          response = await generalApiRequest(`physiotherapy_sessions/${this.editingRecord.id}`, "PUT", payload, 1);
        } else {
          response = await generalApiRequest("physiotherapy_sessions", "POST", payload, 1);
        }
        if (response.success) {
          this.$emit("saved", response.data);
          this.closeModal();
        } else {
          alert(response.message || "Failed to save record");
        }
      } catch (error) {
        console.error("Error saving record:", error);
        alert("An error occurred while saving");
      } finally {
        this.saving = false;
      }
    },
  },
};
</script>

<style scoped>
.modal-overlay { position: fixed; top: 0; left: 0; right: 0; bottom: 0; background: rgba(0,0,0,0.5); display: flex; align-items: center; justify-content: center; z-index: 1000; }
.mmodal-content { background: white; border-radius: 10px; max-height: 90vh; overflow-y: auto; display: flex; flex-direction: column; }
.modal-header { padding: 20px; background: linear-gradient(135deg, #38a169 0%, #276749 100%); color: white; display: flex; justify-content: space-between; align-items: center; }
.modal-header h3 { margin: 0; font-size: 20px; }
.close { background: rgb(233, 22, 22); border: 1px solid rgb(182, 178, 178); font-size: 1.5rem; color: white; line-height: 1; cursor: pointer; }
.modal-body { padding: 30px; overflow-y: auto; flex-grow: 1; }
.form-grid { display: grid; grid-template-columns: repeat(3, 1fr); gap: 20px; margin-bottom: 20px; }
.form-group { margin-bottom: 15px; }
.form-group.full-width { grid-column: 1 / -1; }
.form-group label { display: block; margin-bottom: 5px; font-weight: 600; color: #495057; }
.checkbox-label { display: flex !important; align-items: center; gap: 8px; margin-top: 28px; }
.form-control { width: 100%; padding: 10px; border: 1px solid #ddd; border-radius: 5px; font-size: 14px; }
.modal-actions { display: flex; justify-content: flex-end; gap: 15px; }
.btn { padding: 10px 25px; border: none; border-radius: 5px; cursor: pointer; font-weight: 600; }
.btn-secondary { background: #6c757d; color: white; }
.btn-secondary:hover { background: #5a6268; }
.btn-primary { background: #276749; color: white; }
.btn-primary:hover { opacity: 0.9; }
.btn-primary:disabled { opacity: 0.6; cursor: not-allowed; }
@media (max-width: 1200px) { .form-grid { grid-template-columns: repeat(2, 1fr); } }
@media (max-width: 768px) { .form-grid { grid-template-columns: 1fr; } }
</style>
